// src/services/codigosCanjeApi.js
// Cliente para /api/ecolab/codigos-canje

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5246';

function tok() { return localStorage.getItem('ecolab_token') || null; }

async function apiGet(path, { auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && tok()) headers.Authorization = `Bearer ${tok()}`;
  const res = await fetch(`${BASE}${path}`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `GET ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

async function apiSend(method, path, body, { auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && tok()) headers.Authorization = `Bearer ${tok()}`;
  const res = await fetch(`${BASE}${path}`, {
    method, headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `${method} ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

async function apiUpload(path, file) {
  const headers = {};
  if (tok()) headers.Authorization = `Bearer ${tok()}`;
  const fd = new FormData();
  fd.append('archivo', file);
  const res = await fetch(`${BASE}${path}`, { method: 'POST', headers, body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `POST ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

// ── Configuración ─────────────────────────────────────────────
export const getConfigCanje = () => apiGet('/api/ecolab/codigos-canje/configuracion');
export const actualizarConfigCanje = (dto) => apiSend('PUT', '/api/ecolab/codigos-canje/configuracion', dto);

// ── Listado y detalle ─────────────────────────────────────────
export const listarCodigosCanje = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, v); });
  const suf = q.toString() ? `?${q}` : '';
  return apiGet(`/api/ecolab/codigos-canje${suf}`);
};
export const getCodigoCanje         = (id)         => apiGet(`/api/ecolab/codigos-canje/${id}`);
export const getCodigosCanjePorAfiliado = (afiliadoId) => apiGet(`/api/ecolab/codigos-canje/por-afiliado/${afiliadoId}`);

// ── Emisión / aprobación / anulación ──────────────────────────
export const emitirCodigoParaSolicitud = (afiliadoId) =>
  apiSend('POST', `/api/ecolab/codigos-canje/emitir-para-solicitud/${afiliadoId}`);
export const aprobarEmisionCodigo = (id) =>
  apiSend('POST', `/api/ecolab/codigos-canje/${id}/aprobar-emision`);
export const anularCodigoCanje = (id, motivo) =>
  apiSend('POST', `/api/ecolab/codigos-canje/${id}/anular`, { motivo });
export const aprobarAsociadoCanje = (id) =>
  apiSend('POST', `/api/ecolab/codigos-canje/${id}/aprobar-asociado`);

// ── Consumo manual ────────────────────────────────────────────
export const registrarConsumoManual = (id, dto) =>
  apiSend('POST', `/api/ecolab/codigos-canje/${id}/consumo-manual`, dto);

// ── Ticket ────────────────────────────────────────────────────
export const subirTicketConsumo = (codigoId, consumoId, file) =>
  apiUpload(`/api/ecolab/codigos-canje/${codigoId}/consumos/${consumoId}/ticket`, file);
